import { createApiRef } from '@backstage/core-plugin-api';

import { Feedback, FeedbackResponse } from './types';

export interface FeedbackApi {
  submitFeedback(feedback: Feedback): Promise<void>;
  getAllFeedback(): Promise<FeedbackResponse[]>;
}

export const feedbackApiRef = createApiRef<FeedbackApi>({
  id: 'plugin.feedback.service',
});